// extracted by mini-css-extract-plugin
export var completionBody = "_by-2";
export var completionCard = "_by-0";
export var completionFooter = "_by-3";
export var completionTitle = "_by-1";